<template>
  <div class="gfr-dropdown-trigger" :data-state="open ? 'open' : 'close'">
    <slot />
  </div>
</template>
<script lang="ts" setup>
const open = inject('open')
</script>
